var exports = {
  "cK": "AppearanceTab.module__previewWrapper___a25MLV",
  "i1": "AppearanceTab.module__previewContainer___a25MLV",
  "OH": "AppearanceTab.module__previewMessagesContainer___a25MLV",
  "Tm": "AppearanceTab.module__previewContainerCompact___a25MLV",
  "VY": "AppearanceTab.module__previewContainerCozy___a25MLV",
  "rP": "AppearanceTab.module__previewOverlay___a25MLV",
};

module.exports = exports;
